import type { ReturnsCalculatedSummaryExchangeItem } from '@itsrever/rever-api'
import { useTranslation } from 'react-i18next'
import { MediaImageIcon } from '@/ui/icons/media-image'

interface NewItemsProps {
  exchangeOrder?: string
  exchangeItems?: ReturnsCalculatedSummaryExchangeItem[]
}

export const NewItems = ({ exchangeItems, exchangeOrder }: NewItemsProps) => {
  const { t } = useTranslation()

  return (
    <section className="w-full rounded-lg border border-neutral-300/50 bg-white p-5 shadow-sm">
      <header className="mb-4 flex items-center justify-between gap-4">
        <h2 className="text-sm font-medium text-neutral-900">
          {t('tracking_new.new_items_title')}
        </h2>
        {exchangeOrder ? (
          <p className="text-xs font-normal text-neutral-600">
            {t('tracking_new.order', { orderId: exchangeOrder })}
          </p>
        ) : (
          <span className="inline-flex shrink-0 items-center gap-1 rounded-md bg-amber-100 px-2 py-1 text-xs font-medium text-[#4F4700]">
            <span className="size-1.5 rounded-full bg-current" />
            {t('tracking_new.pending')}
          </span>
        )}
      </header>
      <ul className="flex flex-col gap-5">
        {exchangeItems?.map((item, i) => (
          <li key={i} className="flex gap-3">
            <div className="relative h-20 w-[4.5rem] shrink-0 overflow-clip rounded-md">
              {item.image_url ? (
                <img
                  src={item.image_url}
                  alt={item.name}
                  height={80}
                  width={72}
                  className="size-full object-cover"
                />
              ) : (
                <div className="flex size-full min-h-0 items-center justify-center bg-neutral-50 text-neutral-500">
                  <MediaImageIcon width={18} height={18} />
                </div>
              )}
              {item.quantity && item.quantity > 1 ? (
                <span className="absolute bottom-1 right-1 rounded-sm bg-white/50 p-0.5 px-1 text-xs font-medium backdrop-blur-sm">
                  x {item.quantity}
                </span>
              ) : null}
            </div>
            <div className="min-w-0 space-y-1">
              <p className="line-clamp-2 text-sm font-normal">{item.name}</p>
              <p className="text-xs font-normal text-neutral-500">
                {item.variant_name}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </section>
  )
}
